"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * EMIL InsuranceService
 * The EMIL InsuranceService API description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kontakt@emil.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoliciesApi = exports.PoliciesApiFactory = exports.PoliciesApiFp = exports.PoliciesApiAxiosParamCreator = void 0;
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * PoliciesApi - axios parameter creator
 * @export
 */
var PoliciesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Request to activate an existing suspended policy by tenant.
         * @summary Activate a suspended policy by tenant
         * @param {string} policyCode The policy code.
         * @param {ActivatePolicyRequestDto} activatePolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePolicy: function (policyCode, activatePolicyRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policyCode' is not null or undefined
                            (0, common_1.assertParamExists)('activatePolicy', 'policyCode', policyCode);
                            // verify required parameter 'activatePolicyRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('activatePolicy', 'activatePolicyRequestDto', activatePolicyRequestDto);
                            localVarPath = "/insuranceservice/v1/policies/{policyCode}/activate"
                                .replace("{".concat("policyCode", "}"), encodeURIComponent(String(policyCode)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(activatePolicyRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This will create a draft policy in the database.
         * @summary Create the draft-policy
         * @param {string} policyCode Unique identifier for the object.
         * @param {CreateDraftPolicyRequestDto} createDraftPolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftPolicy: function (policyCode, createDraftPolicyRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policyCode' is not null or undefined
                            (0, common_1.assertParamExists)('createDraftPolicy', 'policyCode', policyCode);
                            // verify required parameter 'createDraftPolicyRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('createDraftPolicy', 'createDraftPolicyRequestDto', createDraftPolicyRequestDto);
                            localVarPath = "/insuranceservice/v1/policies/{policyCode}/draft"
                                .replace("{".concat("policyCode", "}"), encodeURIComponent(String(policyCode)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createDraftPolicyRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This will create a policy in the database. Policy creation is usually part     of a complex workflow that starts with lead creation. Creating directly a policy without prior knowledge     might result in an unusable policy. Look into lead creation for more information.
         * @summary Create the policy
         * @param {CreatePolicyRequestDto} createPolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicy: function (createPolicyRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createPolicyRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('createPolicy', 'createPolicyRequestDto', createPolicyRequestDto);
                            localVarPath = "/insuranceservice/v1/policies";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createPolicyRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Permanently deletes the draft-policy. Supply the unique code that was returned when you created the draft-policy and this will delete it.
         * @summary Delete the draft-policy
         * @param {string} policyCode Unique identifier for the object.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDraftPolicy: function (policyCode, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policyCode' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDraftPolicy', 'policyCode', policyCode);
                            localVarPath = "/insuranceservice/v1/policies/{policyCode}/draft"
                                .replace("{".concat("policyCode", "}"), encodeURIComponent(String(policyCode)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves the details of the draft-policy that was previously created. Supply the unique draft-policy code        that was returned when you created it and Emil Api will return the corresponding draft-policy information.
         * @summary Retrieve the draft-policy
         * @param {string} policyCode Unique identifier for the object.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {string} [expand] Fields to expand response by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftPolicy: function (policyCode, authorization, expand, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policyCode' is not null or undefined
                            (0, common_1.assertParamExists)('getDraftPolicy', 'policyCode', policyCode);
                            localVarPath = "/insuranceservice/v1/policies/{policyCode}/draft"
                                .replace("{".concat("policyCode", "}"), encodeURIComponent(String(policyCode)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (expand !== undefined) {
                                localVarQueryParameter['expand'] = expand;
                            }
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves the details of the policy that was previously created. Supply the unique policy code        that was returned when you created it and Emil Api will return the corresponding policy information.
         * @summary Retrieve the policy
         * @param {string} code Unique identifier for the object.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {string} [expand] You can expand policy in this endpoint. \&#39; +       \&#39;By default, versions and partnerLinks will be an empty array. Allowed values: versions, product, timelines, premiums, premiumItems, premiumFormulas, currentVersion, currentTimelines, currentPremiums, currentPremiumItems, currentPremiumFormulas, partnerLinks.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicy: function (code, authorization, expand, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'code' is not null or undefined
                            (0, common_1.assertParamExists)('getPolicy', 'code', code);
                            localVarPath = "/insuranceservice/v1/policies/{code}"
                                .replace("{".concat("code", "}"), encodeURIComponent(String(code)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (expand !== undefined) {
                                localVarQueryParameter['expand'] = expand;
                            }
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint will return the current version of the policy. It is possible to filter the       response by a specific date and the system will return the valid data that was (or will be) at the       provided date.
         * @summary Retrieve current policy version
         * @param {string} code Unique identifier for the object.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {string} [timesliceDate] This date is used to filter data of the policy, to select the appropriate timeslice.       If no date is specified, the system returns all the timeslices available.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyDataByDate: function (code, authorization, timesliceDate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'code' is not null or undefined
                            (0, common_1.assertParamExists)('getPolicyDataByDate', 'code', code);
                            localVarPath = "/insuranceservice/v1/policies/{code}/current-version"
                                .replace("{".concat("code", "}"), encodeURIComponent(String(code)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (timesliceDate !== undefined) {
                                localVarQueryParameter['timesliceDate'] = timesliceDate;
                            }
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of policies you have previously created.          The policies are returned in sorted order, with the oldest one appearing first.          For more information about pagination, read the Pagination documentation.
         * @summary List policies
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {any} [pageSize] A limit on the number of objects to be returned.     Limit ranges between 1 and 50. Default: 10.
         * @param {any} [pageToken] A cursor for use in pagination.     pageToken is an ID that defines your place in the list.     For instance, if you make a list request and receive 100 objects and pageToken&#x3D;1,     your subsequent call can include pageToken&#x3D;2 in order to fetch the next page of the list.
         * @param {string} [filter] Filter the response by one or multiple fields.            In general, fetching filtered responses will conserve bandwidth and reduce response time.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, code, leadCode, policyNumber, holder, policyStartDate, productSlug, productVersionId, productId, accountCode, productName, status, statuses, createdAt, policyData&lt;/i&gt;
         * @param {any} [search] To search the list by any field, pass search&#x3D;xxx to fetch the result.
         * @param {string} [order] Order allows you to specify the desired order of entities retrieved from the server by           ascending (ASC) or descending (DESC) order.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, policyNumber, createdAt, updatedAt, policyStartDate, productVersionId, productId&lt;/i&gt;
         * @param {string} [expand] Expand to fetch additional information about the list items.           Expanding resources can reduce the number of API calls required to accomplish a task.           Use with discretion as some expanded fields can drastically increase payload size.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: versions, product, timelines, premiums, premiumItems, premiumFormulas, currentVersion, currentTimelines, currentPremiums, currentPremiumItems, currentPremiumFormulas, partnerLinks.&lt;i&gt;
         * @param {string} [filters] Filters the response by one or multiple fields.            Advanced filter functionality allows you to perform more complex filtering operations.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, code, leadCode, policyNumber, holder, policyStartDate, productSlug, productVersionId, productId, accountCode, productName, status, statuses, createdAt, policyData&lt;/i&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPolicies: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/insuranceservice/v1/policies";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (pageToken !== undefined) {
                                localVarQueryParameter['pageToken'] = pageToken;
                            }
                            if (filter !== undefined) {
                                localVarQueryParameter['filter'] = filter;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (expand !== undefined) {
                                localVarQueryParameter['expand'] = expand;
                            }
                            if (filters !== undefined) {
                                localVarQueryParameter['filters'] = filters;
                            }
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of policy objects you have previously created.          The policy objects are returned in sorted order, with the oldest one appearing first.          For more information about pagination, read the Pagination documentation.
         * @summary List policy objects
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {any} [pageSize] A limit on the number of objects to be returned.     Limit ranges between 1 and 50. Default: 10.
         * @param {any} [pageToken] A cursor for use in pagination.     pageToken is an ID that defines your place in the list.     For instance, if you make a list request and receive 100 objects and pageToken&#x3D;1,     your subsequent call can include pageToken&#x3D;2 in order to fetch the next page of the list.
         * @param {string} [filter] Filter the response by one or multiple fields.            In general, fetching filtered responses will conserve bandwidth and reduce response time.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, code, insuredObjectId, insuredObjectName, policyCode, date&lt;/i&gt;
         * @param {any} [search] To search the list by any field, pass search&#x3D;xxx to fetch the result.
         * @param {string} [order] Order allows you to specify the desired order of entities retrieved from the server by           ascending (ASC) or descending (DESC) order.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, code, timesliceId, insuredObjectId, createdAt, updatedAt&lt;/i&gt;
         * @param {any} [expand] Use this parameter to fetch additional information about the list items.     The expand query parameter increases the set of fields that appear in the response in     addition to the default ones.     Expanding resources can reduce the number of API calls required to accomplish a task.     However, use this with parsimony as some expanded fields can drastically increase payload size.
         * @param {string} [filters] Filters the response by one or multiple fields.            Advanced filter functionality allows you to perform more complex filtering operations.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, code, insuredObjectId, insuredObjectName, policyCode, date&lt;/i&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPolicyObjects: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/insuranceservice/v1/policies/policy-objects";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (pageToken !== undefined) {
                                localVarQueryParameter['pageToken'] = pageToken;
                            }
                            if (filter !== undefined) {
                                localVarQueryParameter['filter'] = filter;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (expand !== undefined) {
                                localVarQueryParameter['expand'] = expand;
                            }
                            if (filters !== undefined) {
                                localVarQueryParameter['filters'] = filters;
                            }
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of policy versions you have previously created.          The policy versions are returned in sorted order, with the oldest one appearing first.          For more information about pagination, read the Pagination documentation.
         * @summary List policy versions
         * @param {string} policyCode
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {any} [pageSize] A limit on the number of objects to be returned.     Limit ranges between 1 and 50. Default: 10.
         * @param {any} [pageToken] A cursor for use in pagination.     pageToken is an ID that defines your place in the list.     For instance, if you make a list request and receive 100 objects and pageToken&#x3D;1,     your subsequent call can include pageToken&#x3D;2 in order to fetch the next page of the list.
         * @param {string} [filter] Filter the response by one or multiple fields.            In general, fetching filtered responses will conserve bandwidth and reduce response time.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, policyId&lt;/i&gt;
         * @param {any} [search] To search the list by any field, pass search&#x3D;xxx to fetch the result.
         * @param {string} [order] Order allows you to specify the desired order of entities retrieved from the server by           ascending (ASC) or descending (DESC) order.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, policyId, createdAt, updatedAt&lt;/i&gt;
         * @param {string} [expand] Expand to fetch additional information about the list items.           Expanding resources can reduce the number of API calls required to accomplish a task.           Use with discretion as some expanded fields can drastically increase payload size.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: timelines, premiums, premiumItems, premiumFormulas.&lt;i&gt;
         * @param {string} [filters] Filters the response by one or multiple fields.            Advanced filter functionality allows you to perform more complex filtering operations.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, policyId&lt;/i&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPolicyVersions: function (policyCode, authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policyCode' is not null or undefined
                            (0, common_1.assertParamExists)('listPolicyVersions', 'policyCode', policyCode);
                            localVarPath = "/insuranceservice/v1/policies/{policyCode}/versions"
                                .replace("{".concat("policyCode", "}"), encodeURIComponent(String(policyCode)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (pageToken !== undefined) {
                                localVarQueryParameter['pageToken'] = pageToken;
                            }
                            if (filter !== undefined) {
                                localVarQueryParameter['filter'] = filter;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (expand !== undefined) {
                                localVarQueryParameter['expand'] = expand;
                            }
                            if (filters !== undefined) {
                                localVarQueryParameter['filters'] = filters;
                            }
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates the specified draft-policy by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the draft-policy
         * @param {string} policyCode Unique identifier for the object.
         * @param {PatchDraftPolicyRequestDto} patchDraftPolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDraftPolicy: function (policyCode, patchDraftPolicyRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policyCode' is not null or undefined
                            (0, common_1.assertParamExists)('patchDraftPolicy', 'policyCode', policyCode);
                            // verify required parameter 'patchDraftPolicyRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('patchDraftPolicy', 'patchDraftPolicyRequestDto', patchDraftPolicyRequestDto);
                            localVarPath = "/insuranceservice/v1/policies/{policyCode}/draft"
                                .replace("{".concat("policyCode", "}"), encodeURIComponent(String(policyCode)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchDraftPolicyRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates the specified policy by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the policy
         * @param {string} code Unique identifier for the object.
         * @param {PatchPolicyRequestDto} patchPolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPolicy: function (code, patchPolicyRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'code' is not null or undefined
                            (0, common_1.assertParamExists)('patchPolicy', 'code', code);
                            // verify required parameter 'patchPolicyRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('patchPolicy', 'patchPolicyRequestDto', patchPolicyRequestDto);
                            localVarPath = "/insuranceservice/v1/policies/{code}"
                                .replace("{".concat("code", "}"), encodeURIComponent(String(code)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchPolicyRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Request to suspend an existing policy by tenant.
         * @summary Suspend a policy by tenant
         * @param {string} policyCode The policy code.
         * @param {SuspendPolicyRequestDto} suspendPolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendPolicy: function (policyCode, suspendPolicyRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policyCode' is not null or undefined
                            (0, common_1.assertParamExists)('suspendPolicy', 'policyCode', policyCode);
                            // verify required parameter 'suspendPolicyRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('suspendPolicy', 'suspendPolicyRequestDto', suspendPolicyRequestDto);
                            localVarPath = "/insuranceservice/v1/policies/{policyCode}/suspend"
                                .replace("{".concat("policyCode", "}"), encodeURIComponent(String(policyCode)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(suspendPolicyRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Request to terminate an existing policy by tenant.
         * @summary Terminate a policy by tenant
         * @param {string} policyCode The policy code.
         * @param {TerminatePolicyRequestDto} terminatePolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminatePolicy: function (policyCode, terminatePolicyRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policyCode' is not null or undefined
                            (0, common_1.assertParamExists)('terminatePolicy', 'policyCode', policyCode);
                            // verify required parameter 'terminatePolicyRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('terminatePolicy', 'terminatePolicyRequestDto', terminatePolicyRequestDto);
                            localVarPath = "/insuranceservice/v1/policies/{policyCode}/terminate"
                                .replace("{".concat("policyCode", "}"), encodeURIComponent(String(policyCode)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(terminatePolicyRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates the specified policy by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the policy
         * @param {string} code Unique identifier for the object.
         * @param {UpdatePolicyRequestDto} updatePolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicy: function (code, updatePolicyRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'code' is not null or undefined
                            (0, common_1.assertParamExists)('updatePolicy', 'code', code);
                            // verify required parameter 'updatePolicyRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('updatePolicy', 'updatePolicyRequestDto', updatePolicyRequestDto);
                            localVarPath = "/insuranceservice/v1/policies/{code}"
                                .replace("{".concat("code", "}"), encodeURIComponent(String(code)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePolicyRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Withdraw policy by tenant.
         * @summary Withdraw policy by tenant
         * @param {string} policyCode The policy code.
         * @param {object} body
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawPolicy: function (policyCode, body, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policyCode' is not null or undefined
                            (0, common_1.assertParamExists)('withdrawPolicy', 'policyCode', policyCode);
                            // verify required parameter 'body' is not null or undefined
                            (0, common_1.assertParamExists)('withdrawPolicy', 'body', body);
                            localVarPath = "/insuranceservice/v1/policies/{policyCode}/withdraw"
                                .replace("{".concat("policyCode", "}"), encodeURIComponent(String(policyCode)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PoliciesApiAxiosParamCreator = PoliciesApiAxiosParamCreator;
/**
 * PoliciesApi - functional programming interface
 * @export
 */
var PoliciesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PoliciesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Request to activate an existing suspended policy by tenant.
         * @summary Activate a suspended policy by tenant
         * @param {string} policyCode The policy code.
         * @param {ActivatePolicyRequestDto} activatePolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePolicy: function (policyCode, activatePolicyRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.activatePolicy(policyCode, activatePolicyRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will create a draft policy in the database.
         * @summary Create the draft-policy
         * @param {string} policyCode Unique identifier for the object.
         * @param {CreateDraftPolicyRequestDto} createDraftPolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftPolicy: function (policyCode, createDraftPolicyRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDraftPolicy(policyCode, createDraftPolicyRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will create a policy in the database. Policy creation is usually part     of a complex workflow that starts with lead creation. Creating directly a policy without prior knowledge     might result in an unusable policy. Look into lead creation for more information.
         * @summary Create the policy
         * @param {CreatePolicyRequestDto} createPolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicy: function (createPolicyRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPolicy(createPolicyRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Permanently deletes the draft-policy. Supply the unique code that was returned when you created the draft-policy and this will delete it.
         * @summary Delete the draft-policy
         * @param {string} policyCode Unique identifier for the object.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDraftPolicy: function (policyCode, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDraftPolicy(policyCode, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves the details of the draft-policy that was previously created. Supply the unique draft-policy code        that was returned when you created it and Emil Api will return the corresponding draft-policy information.
         * @summary Retrieve the draft-policy
         * @param {string} policyCode Unique identifier for the object.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {string} [expand] Fields to expand response by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftPolicy: function (policyCode, authorization, expand, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDraftPolicy(policyCode, authorization, expand, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves the details of the policy that was previously created. Supply the unique policy code        that was returned when you created it and Emil Api will return the corresponding policy information.
         * @summary Retrieve the policy
         * @param {string} code Unique identifier for the object.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {string} [expand] You can expand policy in this endpoint. \&#39; +       \&#39;By default, versions and partnerLinks will be an empty array. Allowed values: versions, product, timelines, premiums, premiumItems, premiumFormulas, currentVersion, currentTimelines, currentPremiums, currentPremiumItems, currentPremiumFormulas, partnerLinks.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicy: function (code, authorization, expand, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPolicy(code, authorization, expand, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This endpoint will return the current version of the policy. It is possible to filter the       response by a specific date and the system will return the valid data that was (or will be) at the       provided date.
         * @summary Retrieve current policy version
         * @param {string} code Unique identifier for the object.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {string} [timesliceDate] This date is used to filter data of the policy, to select the appropriate timeslice.       If no date is specified, the system returns all the timeslices available.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyDataByDate: function (code, authorization, timesliceDate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPolicyDataByDate(code, authorization, timesliceDate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a list of policies you have previously created.          The policies are returned in sorted order, with the oldest one appearing first.          For more information about pagination, read the Pagination documentation.
         * @summary List policies
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {any} [pageSize] A limit on the number of objects to be returned.     Limit ranges between 1 and 50. Default: 10.
         * @param {any} [pageToken] A cursor for use in pagination.     pageToken is an ID that defines your place in the list.     For instance, if you make a list request and receive 100 objects and pageToken&#x3D;1,     your subsequent call can include pageToken&#x3D;2 in order to fetch the next page of the list.
         * @param {string} [filter] Filter the response by one or multiple fields.            In general, fetching filtered responses will conserve bandwidth and reduce response time.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, code, leadCode, policyNumber, holder, policyStartDate, productSlug, productVersionId, productId, accountCode, productName, status, statuses, createdAt, policyData&lt;/i&gt;
         * @param {any} [search] To search the list by any field, pass search&#x3D;xxx to fetch the result.
         * @param {string} [order] Order allows you to specify the desired order of entities retrieved from the server by           ascending (ASC) or descending (DESC) order.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, policyNumber, createdAt, updatedAt, policyStartDate, productVersionId, productId&lt;/i&gt;
         * @param {string} [expand] Expand to fetch additional information about the list items.           Expanding resources can reduce the number of API calls required to accomplish a task.           Use with discretion as some expanded fields can drastically increase payload size.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: versions, product, timelines, premiums, premiumItems, premiumFormulas, currentVersion, currentTimelines, currentPremiums, currentPremiumItems, currentPremiumFormulas, partnerLinks.&lt;i&gt;
         * @param {string} [filters] Filters the response by one or multiple fields.            Advanced filter functionality allows you to perform more complex filtering operations.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, code, leadCode, policyNumber, holder, policyStartDate, productSlug, productVersionId, productId, accountCode, productName, status, statuses, createdAt, policyData&lt;/i&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPolicies: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listPolicies(authorization, pageSize, pageToken, filter, search, order, expand, filters, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a list of policy objects you have previously created.          The policy objects are returned in sorted order, with the oldest one appearing first.          For more information about pagination, read the Pagination documentation.
         * @summary List policy objects
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {any} [pageSize] A limit on the number of objects to be returned.     Limit ranges between 1 and 50. Default: 10.
         * @param {any} [pageToken] A cursor for use in pagination.     pageToken is an ID that defines your place in the list.     For instance, if you make a list request and receive 100 objects and pageToken&#x3D;1,     your subsequent call can include pageToken&#x3D;2 in order to fetch the next page of the list.
         * @param {string} [filter] Filter the response by one or multiple fields.            In general, fetching filtered responses will conserve bandwidth and reduce response time.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, code, insuredObjectId, insuredObjectName, policyCode, date&lt;/i&gt;
         * @param {any} [search] To search the list by any field, pass search&#x3D;xxx to fetch the result.
         * @param {string} [order] Order allows you to specify the desired order of entities retrieved from the server by           ascending (ASC) or descending (DESC) order.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, code, timesliceId, insuredObjectId, createdAt, updatedAt&lt;/i&gt;
         * @param {any} [expand] Use this parameter to fetch additional information about the list items.     The expand query parameter increases the set of fields that appear in the response in     addition to the default ones.     Expanding resources can reduce the number of API calls required to accomplish a task.     However, use this with parsimony as some expanded fields can drastically increase payload size.
         * @param {string} [filters] Filters the response by one or multiple fields.            Advanced filter functionality allows you to perform more complex filtering operations.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, code, insuredObjectId, insuredObjectName, policyCode, date&lt;/i&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPolicyObjects: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listPolicyObjects(authorization, pageSize, pageToken, filter, search, order, expand, filters, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a list of policy versions you have previously created.          The policy versions are returned in sorted order, with the oldest one appearing first.          For more information about pagination, read the Pagination documentation.
         * @summary List policy versions
         * @param {string} policyCode
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {any} [pageSize] A limit on the number of objects to be returned.     Limit ranges between 1 and 50. Default: 10.
         * @param {any} [pageToken] A cursor for use in pagination.     pageToken is an ID that defines your place in the list.     For instance, if you make a list request and receive 100 objects and pageToken&#x3D;1,     your subsequent call can include pageToken&#x3D;2 in order to fetch the next page of the list.
         * @param {string} [filter] Filter the response by one or multiple fields.            In general, fetching filtered responses will conserve bandwidth and reduce response time.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, policyId&lt;/i&gt;
         * @param {any} [search] To search the list by any field, pass search&#x3D;xxx to fetch the result.
         * @param {string} [order] Order allows you to specify the desired order of entities retrieved from the server by           ascending (ASC) or descending (DESC) order.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, policyId, createdAt, updatedAt&lt;/i&gt;
         * @param {string} [expand] Expand to fetch additional information about the list items.           Expanding resources can reduce the number of API calls required to accomplish a task.           Use with discretion as some expanded fields can drastically increase payload size.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: timelines, premiums, premiumItems, premiumFormulas.&lt;i&gt;
         * @param {string} [filters] Filters the response by one or multiple fields.            Advanced filter functionality allows you to perform more complex filtering operations.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, policyId&lt;/i&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPolicyVersions: function (policyCode, authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listPolicyVersions(policyCode, authorization, pageSize, pageToken, filter, search, order, expand, filters, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates the specified draft-policy by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the draft-policy
         * @param {string} policyCode Unique identifier for the object.
         * @param {PatchDraftPolicyRequestDto} patchDraftPolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDraftPolicy: function (policyCode, patchDraftPolicyRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchDraftPolicy(policyCode, patchDraftPolicyRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates the specified policy by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the policy
         * @param {string} code Unique identifier for the object.
         * @param {PatchPolicyRequestDto} patchPolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPolicy: function (code, patchPolicyRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchPolicy(code, patchPolicyRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Request to suspend an existing policy by tenant.
         * @summary Suspend a policy by tenant
         * @param {string} policyCode The policy code.
         * @param {SuspendPolicyRequestDto} suspendPolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendPolicy: function (policyCode, suspendPolicyRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.suspendPolicy(policyCode, suspendPolicyRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Request to terminate an existing policy by tenant.
         * @summary Terminate a policy by tenant
         * @param {string} policyCode The policy code.
         * @param {TerminatePolicyRequestDto} terminatePolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminatePolicy: function (policyCode, terminatePolicyRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.terminatePolicy(policyCode, terminatePolicyRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates the specified policy by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the policy
         * @param {string} code Unique identifier for the object.
         * @param {UpdatePolicyRequestDto} updatePolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicy: function (code, updatePolicyRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePolicy(code, updatePolicyRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Withdraw policy by tenant.
         * @summary Withdraw policy by tenant
         * @param {string} policyCode The policy code.
         * @param {object} body
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawPolicy: function (policyCode, body, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.withdrawPolicy(policyCode, body, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PoliciesApiFp = PoliciesApiFp;
/**
 * PoliciesApi - factory interface
 * @export
 */
var PoliciesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PoliciesApiFp)(configuration);
    return {
        /**
         * Request to activate an existing suspended policy by tenant.
         * @summary Activate a suspended policy by tenant
         * @param {string} policyCode The policy code.
         * @param {ActivatePolicyRequestDto} activatePolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePolicy: function (policyCode, activatePolicyRequestDto, authorization, options) {
            return localVarFp.activatePolicy(policyCode, activatePolicyRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will create a draft policy in the database.
         * @summary Create the draft-policy
         * @param {string} policyCode Unique identifier for the object.
         * @param {CreateDraftPolicyRequestDto} createDraftPolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftPolicy: function (policyCode, createDraftPolicyRequestDto, authorization, options) {
            return localVarFp.createDraftPolicy(policyCode, createDraftPolicyRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will create a policy in the database. Policy creation is usually part     of a complex workflow that starts with lead creation. Creating directly a policy without prior knowledge     might result in an unusable policy. Look into lead creation for more information.
         * @summary Create the policy
         * @param {CreatePolicyRequestDto} createPolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicy: function (createPolicyRequestDto, authorization, options) {
            return localVarFp.createPolicy(createPolicyRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Permanently deletes the draft-policy. Supply the unique code that was returned when you created the draft-policy and this will delete it.
         * @summary Delete the draft-policy
         * @param {string} policyCode Unique identifier for the object.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDraftPolicy: function (policyCode, authorization, options) {
            return localVarFp.deleteDraftPolicy(policyCode, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves the details of the draft-policy that was previously created. Supply the unique draft-policy code        that was returned when you created it and Emil Api will return the corresponding draft-policy information.
         * @summary Retrieve the draft-policy
         * @param {string} policyCode Unique identifier for the object.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {string} [expand] Fields to expand response by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftPolicy: function (policyCode, authorization, expand, options) {
            return localVarFp.getDraftPolicy(policyCode, authorization, expand, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves the details of the policy that was previously created. Supply the unique policy code        that was returned when you created it and Emil Api will return the corresponding policy information.
         * @summary Retrieve the policy
         * @param {string} code Unique identifier for the object.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {string} [expand] You can expand policy in this endpoint. \&#39; +       \&#39;By default, versions and partnerLinks will be an empty array. Allowed values: versions, product, timelines, premiums, premiumItems, premiumFormulas, currentVersion, currentTimelines, currentPremiums, currentPremiumItems, currentPremiumFormulas, partnerLinks.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicy: function (code, authorization, expand, options) {
            return localVarFp.getPolicy(code, authorization, expand, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint will return the current version of the policy. It is possible to filter the       response by a specific date and the system will return the valid data that was (or will be) at the       provided date.
         * @summary Retrieve current policy version
         * @param {string} code Unique identifier for the object.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {string} [timesliceDate] This date is used to filter data of the policy, to select the appropriate timeslice.       If no date is specified, the system returns all the timeslices available.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyDataByDate: function (code, authorization, timesliceDate, options) {
            return localVarFp.getPolicyDataByDate(code, authorization, timesliceDate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of policies you have previously created.          The policies are returned in sorted order, with the oldest one appearing first.          For more information about pagination, read the Pagination documentation.
         * @summary List policies
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {any} [pageSize] A limit on the number of objects to be returned.     Limit ranges between 1 and 50. Default: 10.
         * @param {any} [pageToken] A cursor for use in pagination.     pageToken is an ID that defines your place in the list.     For instance, if you make a list request and receive 100 objects and pageToken&#x3D;1,     your subsequent call can include pageToken&#x3D;2 in order to fetch the next page of the list.
         * @param {string} [filter] Filter the response by one or multiple fields.            In general, fetching filtered responses will conserve bandwidth and reduce response time.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, code, leadCode, policyNumber, holder, policyStartDate, productSlug, productVersionId, productId, accountCode, productName, status, statuses, createdAt, policyData&lt;/i&gt;
         * @param {any} [search] To search the list by any field, pass search&#x3D;xxx to fetch the result.
         * @param {string} [order] Order allows you to specify the desired order of entities retrieved from the server by           ascending (ASC) or descending (DESC) order.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, policyNumber, createdAt, updatedAt, policyStartDate, productVersionId, productId&lt;/i&gt;
         * @param {string} [expand] Expand to fetch additional information about the list items.           Expanding resources can reduce the number of API calls required to accomplish a task.           Use with discretion as some expanded fields can drastically increase payload size.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: versions, product, timelines, premiums, premiumItems, premiumFormulas, currentVersion, currentTimelines, currentPremiums, currentPremiumItems, currentPremiumFormulas, partnerLinks.&lt;i&gt;
         * @param {string} [filters] Filters the response by one or multiple fields.            Advanced filter functionality allows you to perform more complex filtering operations.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, code, leadCode, policyNumber, holder, policyStartDate, productSlug, productVersionId, productId, accountCode, productName, status, statuses, createdAt, policyData&lt;/i&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPolicies: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            return localVarFp.listPolicies(authorization, pageSize, pageToken, filter, search, order, expand, filters, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of policy objects you have previously created.          The policy objects are returned in sorted order, with the oldest one appearing first.          For more information about pagination, read the Pagination documentation.
         * @summary List policy objects
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {any} [pageSize] A limit on the number of objects to be returned.     Limit ranges between 1 and 50. Default: 10.
         * @param {any} [pageToken] A cursor for use in pagination.     pageToken is an ID that defines your place in the list.     For instance, if you make a list request and receive 100 objects and pageToken&#x3D;1,     your subsequent call can include pageToken&#x3D;2 in order to fetch the next page of the list.
         * @param {string} [filter] Filter the response by one or multiple fields.            In general, fetching filtered responses will conserve bandwidth and reduce response time.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, code, insuredObjectId, insuredObjectName, policyCode, date&lt;/i&gt;
         * @param {any} [search] To search the list by any field, pass search&#x3D;xxx to fetch the result.
         * @param {string} [order] Order allows you to specify the desired order of entities retrieved from the server by           ascending (ASC) or descending (DESC) order.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, code, timesliceId, insuredObjectId, createdAt, updatedAt&lt;/i&gt;
         * @param {any} [expand] Use this parameter to fetch additional information about the list items.     The expand query parameter increases the set of fields that appear in the response in     addition to the default ones.     Expanding resources can reduce the number of API calls required to accomplish a task.     However, use this with parsimony as some expanded fields can drastically increase payload size.
         * @param {string} [filters] Filters the response by one or multiple fields.            Advanced filter functionality allows you to perform more complex filtering operations.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, code, insuredObjectId, insuredObjectName, policyCode, date&lt;/i&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPolicyObjects: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            return localVarFp.listPolicyObjects(authorization, pageSize, pageToken, filter, search, order, expand, filters, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of policy versions you have previously created.          The policy versions are returned in sorted order, with the oldest one appearing first.          For more information about pagination, read the Pagination documentation.
         * @summary List policy versions
         * @param {string} policyCode
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {any} [pageSize] A limit on the number of objects to be returned.     Limit ranges between 1 and 50. Default: 10.
         * @param {any} [pageToken] A cursor for use in pagination.     pageToken is an ID that defines your place in the list.     For instance, if you make a list request and receive 100 objects and pageToken&#x3D;1,     your subsequent call can include pageToken&#x3D;2 in order to fetch the next page of the list.
         * @param {string} [filter] Filter the response by one or multiple fields.            In general, fetching filtered responses will conserve bandwidth and reduce response time.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, policyId&lt;/i&gt;
         * @param {any} [search] To search the list by any field, pass search&#x3D;xxx to fetch the result.
         * @param {string} [order] Order allows you to specify the desired order of entities retrieved from the server by           ascending (ASC) or descending (DESC) order.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, policyId, createdAt, updatedAt&lt;/i&gt;
         * @param {string} [expand] Expand to fetch additional information about the list items.           Expanding resources can reduce the number of API calls required to accomplish a task.           Use with discretion as some expanded fields can drastically increase payload size.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: timelines, premiums, premiumItems, premiumFormulas.&lt;i&gt;
         * @param {string} [filters] Filters the response by one or multiple fields.            Advanced filter functionality allows you to perform more complex filtering operations.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, policyId&lt;/i&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPolicyVersions: function (policyCode, authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            return localVarFp.listPolicyVersions(policyCode, authorization, pageSize, pageToken, filter, search, order, expand, filters, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the specified draft-policy by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the draft-policy
         * @param {string} policyCode Unique identifier for the object.
         * @param {PatchDraftPolicyRequestDto} patchDraftPolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDraftPolicy: function (policyCode, patchDraftPolicyRequestDto, authorization, options) {
            return localVarFp.patchDraftPolicy(policyCode, patchDraftPolicyRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the specified policy by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the policy
         * @param {string} code Unique identifier for the object.
         * @param {PatchPolicyRequestDto} patchPolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPolicy: function (code, patchPolicyRequestDto, authorization, options) {
            return localVarFp.patchPolicy(code, patchPolicyRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Request to suspend an existing policy by tenant.
         * @summary Suspend a policy by tenant
         * @param {string} policyCode The policy code.
         * @param {SuspendPolicyRequestDto} suspendPolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendPolicy: function (policyCode, suspendPolicyRequestDto, authorization, options) {
            return localVarFp.suspendPolicy(policyCode, suspendPolicyRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Request to terminate an existing policy by tenant.
         * @summary Terminate a policy by tenant
         * @param {string} policyCode The policy code.
         * @param {TerminatePolicyRequestDto} terminatePolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminatePolicy: function (policyCode, terminatePolicyRequestDto, authorization, options) {
            return localVarFp.terminatePolicy(policyCode, terminatePolicyRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the specified policy by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the policy
         * @param {string} code Unique identifier for the object.
         * @param {UpdatePolicyRequestDto} updatePolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicy: function (code, updatePolicyRequestDto, authorization, options) {
            return localVarFp.updatePolicy(code, updatePolicyRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Withdraw policy by tenant.
         * @summary Withdraw policy by tenant
         * @param {string} policyCode The policy code.
         * @param {object} body
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawPolicy: function (policyCode, body, authorization, options) {
            return localVarFp.withdrawPolicy(policyCode, body, authorization, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PoliciesApiFactory = PoliciesApiFactory;
/**
 * PoliciesApi - object-oriented interface
 * @export
 * @class PoliciesApi
 * @extends {BaseAPI}
 */
var PoliciesApi = /** @class */ (function (_super) {
    __extends(PoliciesApi, _super);
    function PoliciesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Request to activate an existing suspended policy by tenant.
     * @summary Activate a suspended policy by tenant
     * @param {PoliciesApiActivatePolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.activatePolicy = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).activatePolicy(requestParameters.policyCode, requestParameters.activatePolicyRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will create a draft policy in the database.
     * @summary Create the draft-policy
     * @param {PoliciesApiCreateDraftPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.createDraftPolicy = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).createDraftPolicy(requestParameters.policyCode, requestParameters.createDraftPolicyRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will create a policy in the database. Policy creation is usually part     of a complex workflow that starts with lead creation. Creating directly a policy without prior knowledge     might result in an unusable policy. Look into lead creation for more information.
     * @summary Create the policy
     * @param {PoliciesApiCreatePolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.createPolicy = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).createPolicy(requestParameters.createPolicyRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Permanently deletes the draft-policy. Supply the unique code that was returned when you created the draft-policy and this will delete it.
     * @summary Delete the draft-policy
     * @param {PoliciesApiDeleteDraftPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.deleteDraftPolicy = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).deleteDraftPolicy(requestParameters.policyCode, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves the details of the draft-policy that was previously created. Supply the unique draft-policy code        that was returned when you created it and Emil Api will return the corresponding draft-policy information.
     * @summary Retrieve the draft-policy
     * @param {PoliciesApiGetDraftPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.getDraftPolicy = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).getDraftPolicy(requestParameters.policyCode, requestParameters.authorization, requestParameters.expand, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves the details of the policy that was previously created. Supply the unique policy code        that was returned when you created it and Emil Api will return the corresponding policy information.
     * @summary Retrieve the policy
     * @param {PoliciesApiGetPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.getPolicy = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).getPolicy(requestParameters.code, requestParameters.authorization, requestParameters.expand, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint will return the current version of the policy. It is possible to filter the       response by a specific date and the system will return the valid data that was (or will be) at the       provided date.
     * @summary Retrieve current policy version
     * @param {PoliciesApiGetPolicyDataByDateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.getPolicyDataByDate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).getPolicyDataByDate(requestParameters.code, requestParameters.authorization, requestParameters.timesliceDate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of policies you have previously created.          The policies are returned in sorted order, with the oldest one appearing first.          For more information about pagination, read the Pagination documentation.
     * @summary List policies
     * @param {PoliciesApiListPoliciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.listPolicies = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.PoliciesApiFp)(this.configuration).listPolicies(requestParameters.authorization, requestParameters.pageSize, requestParameters.pageToken, requestParameters.filter, requestParameters.search, requestParameters.order, requestParameters.expand, requestParameters.filters, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of policy objects you have previously created.          The policy objects are returned in sorted order, with the oldest one appearing first.          For more information about pagination, read the Pagination documentation.
     * @summary List policy objects
     * @param {PoliciesApiListPolicyObjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.listPolicyObjects = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.PoliciesApiFp)(this.configuration).listPolicyObjects(requestParameters.authorization, requestParameters.pageSize, requestParameters.pageToken, requestParameters.filter, requestParameters.search, requestParameters.order, requestParameters.expand, requestParameters.filters, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of policy versions you have previously created.          The policy versions are returned in sorted order, with the oldest one appearing first.          For more information about pagination, read the Pagination documentation.
     * @summary List policy versions
     * @param {PoliciesApiListPolicyVersionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.listPolicyVersions = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).listPolicyVersions(requestParameters.policyCode, requestParameters.authorization, requestParameters.pageSize, requestParameters.pageToken, requestParameters.filter, requestParameters.search, requestParameters.order, requestParameters.expand, requestParameters.filters, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the specified draft-policy by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
     * @summary Update the draft-policy
     * @param {PoliciesApiPatchDraftPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.patchDraftPolicy = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).patchDraftPolicy(requestParameters.policyCode, requestParameters.patchDraftPolicyRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the specified policy by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
     * @summary Update the policy
     * @param {PoliciesApiPatchPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.patchPolicy = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).patchPolicy(requestParameters.code, requestParameters.patchPolicyRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Request to suspend an existing policy by tenant.
     * @summary Suspend a policy by tenant
     * @param {PoliciesApiSuspendPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.suspendPolicy = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).suspendPolicy(requestParameters.policyCode, requestParameters.suspendPolicyRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Request to terminate an existing policy by tenant.
     * @summary Terminate a policy by tenant
     * @param {PoliciesApiTerminatePolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.terminatePolicy = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).terminatePolicy(requestParameters.policyCode, requestParameters.terminatePolicyRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the specified policy by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
     * @summary Update the policy
     * @param {PoliciesApiUpdatePolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.updatePolicy = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).updatePolicy(requestParameters.code, requestParameters.updatePolicyRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Withdraw policy by tenant.
     * @summary Withdraw policy by tenant
     * @param {PoliciesApiWithdrawPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.withdrawPolicy = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).withdrawPolicy(requestParameters.policyCode, requestParameters.body, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PoliciesApi;
}(base_1.BaseAPI));
exports.PoliciesApi = PoliciesApi;
